import React from 'react'
import styled from '@emotion/styled'
import { withStyles } from '@material-ui/core/styles'
import MuiDialog from '@material-ui/core/Dialog'
import Typography from '@/components/common/Typography'
import GhostButton from '@/components/common/GhostButton'
import { rem } from '@/utils/helpers'

const Dialog = withStyles(theme => ({
  paper: {
    margin: `${rem(16)}'`,
    maxWidth: `${rem(520)}`
  }
}))(MuiDialog)

const DialogContent = styled.div`
  padding: ${rem(32)} ${rem(24)};
`

const Title = styled(Typography)`
  text-align: center;
`

const Message = styled(Typography)`
  margin-top: ${rem(20)};
`

const Close = styled(GhostButton)`
  display: block;
  margin: ${rem(24)} auto 0;
  width: ${rem(120)};
`

const Component = props => (
  <Dialog open={props.open} onClose={props.onClose}>
    <DialogContent>
      <Title variant="h2" color="primary">{props.title}</Title>
      <Message variant="body2" type="contrast">{props.children}</Message>
      <Close type="contrast" onClick={props.onClose}>閉じる</Close>
    </DialogContent>
  </Dialog>
)
export default Component
